import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import HomePage from "@/pages/Home";

export const Route = createFileRoute("/$lang/")({
  head: ({ params }) => pageHead(params.lang, "home"),
  component: HomePage,
});
